import React from "react";
import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// A Meta devolve mais de dois estados aqui. Tratar tudo que nao e VERIFIED como
// "nao verificado" faz um numero saudavel (quality GREEN, so com o codigo de
// verificacao vencido) parecer quebrado — por isso EXPIRED tem rotulo proprio,
// e estados desconhecidos mostram o valor cru em vez de virarem alarme falso.
const rotuloVerificacao = (status) => {
  if (status === "VERIFIED") {
    return i18n.t("whatsappOficialWizard.numero.verificado");
  }
  if (status === "EXPIRED") {
    return i18n.t("whatsappOficialWizard.numero.verificacaoExpirada");
  }
  if (!status || status === "NOT_VERIFIED") {
    return i18n.t("whatsappOficialWizard.numero.naoVerificado");
  }
  return `${i18n.t("whatsappOficialWizard.numero.verificacao")}: ${status}`;
};

const StepNumero = ({ state, dispatch }) => {
  const businesses = state.descoberta ? state.descoberta.businesses : [];
  const business = businesses.find((b) => b.business_id === state.businessId);
  const wabas = business ? business.wabas : [];
  const waba = wabas.find((w) => w.waba_id === state.wabaId);
  const numeros = waba ? waba.phone_numbers : [];

  const setCampo = (campo) => (e) =>
    dispatch({ type: "SET_CAMPO", campo, valor: e.target.value });

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {i18n.t("whatsappOficialWizard.numero.titulo")}
      </Typography>

      {businesses.length > 1 && (
        <FormControl variant="outlined" margin="dense" fullWidth>
          <InputLabel>{i18n.t("whatsappOficialWizard.numero.negocio")}</InputLabel>
          <Select
            value={state.businessId}
            onChange={setCampo("businessId")}
            label={i18n.t("whatsappOficialWizard.numero.negocio")}
          >
            {businesses.map((b) => (
              <MenuItem key={b.business_id} value={b.business_id}>
                {b.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      <FormControl variant="outlined" margin="dense" fullWidth>
        <InputLabel>{i18n.t("whatsappOficialWizard.numero.waba")}</InputLabel>
        <Select
          value={state.wabaId}
          onChange={setCampo("wabaId")}
          label={i18n.t("whatsappOficialWizard.numero.waba")}
        >
          {wabas.map((w) => (
            <MenuItem key={w.waba_id} value={w.waba_id}>
              {w.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" margin="dense" fullWidth>
        <InputLabel>{i18n.t("whatsappOficialWizard.numero.numero")}</InputLabel>
        <Select
          value={state.phoneNumberId}
          onChange={setCampo("phoneNumberId")}
          label={i18n.t("whatsappOficialWizard.numero.numero")}
        >
          {numeros.map((n) => (
            <MenuItem key={n.phone_number_id} value={n.phone_number_id}>
              {n.display_phone_number} — {n.verified_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {state.wabaId && numeros.length === 0 && (
        <Typography variant="body2" color="error">
          {i18n.t("whatsappOficialWizard.numero.semNumeros")}
        </Typography>
      )}

      {numeros
        .filter((n) => n.phone_number_id === state.phoneNumberId)
        .map((n) => (
          <div key={n.phone_number_id} style={{ marginTop: 12 }}>
            <Chip
              size="small"
              style={{ marginRight: 8 }}
              label={`${i18n.t("whatsappOficialWizard.numero.qualidade")}: ${
                n.quality_rating || "—"
              }`}
            />
            <Chip size="small" label={rotuloVerificacao(n.code_verification_status)} />
          </div>
        ))}
    </div>
  );
};

export default StepNumero;
